import { Service_CN, Service_GL } from "../CommonFunc";

export const IMAGE_DNS: string = "https://file.valofe.com";
export const VFUN_IMAGE_DNS: string = "https://file.valofe.com/Valofe_file";

export const VERIFY_KEY: string = "ehG.NSdz.qoffhvm!@";

// 머니
export const BILLING_CHARGE_URL = (service_code: string) => {
  return (
    process.env.REACT_APP_VFUN_API_DNS +
    `${
      Service_GL
        ? `/common/redirect/billing?service_code=${service_code}&type=purchase`
        : "/mycash/charge_info.asp"
    }`
  );
};
export const HISTORY_CHARGE_URL: string =
  process.env.REACT_APP_HISTORY_DNS + "charge_history.asp";

export const SERVICE_CODE = "vfun";

export const SIGN_IN_URL = (service_code: string) => {
  const incodeUrl = encodeURIComponent(window.location.href);

  const service_type_link = () => {
    if (Service_GL) {
      if (Service_CN) {
        return `/membership?redirect=${incodeUrl}&game_id=${service_code}`;
      } else {
        return `/membership/signin?service_code=${service_code}&ret=${incodeUrl}`;
      }
    } else {
      return `/login/login.asp?ret=${incodeUrl}`;
    }
  };

  return process.env.REACT_APP_MEMBER_DNS + service_type_link();
};

export const SIGN_UP_URL = (service_code: string) => {
  const incodeUrl = encodeURIComponent(window.location.href);

  const service_type_link = () => {
    if (Service_GL) {
      if (Service_CN) {
        return `/membership/signup?game_id=${service_code}&regfrom=xiyouxi&redirect=http%3A%2F%2Fc9.bbs.xiyouxi.com%2F`;
      } else {
        return `/membership/signup?service_code=${service_code}&ret=${incodeUrl}`;
      }
    } else {
      return `/join/member_join_pre.asp`;
    }
  };

  return process.env.REACT_APP_MEMBER_DNS + service_type_link();
};

export const NAVER_SIGN_IN_URL: string = `https://nid.naver.com/nidlogin.login?url=https://game.naver.com/login.nhn?nxtUrl=${window.location.origin}/page/`;

export const MY_INFO_URL = () => {
  const incodeUrl = encodeURIComponent(window.location.href);

  const service_type_link = () => {
    if (Service_GL) {
      if (Service_CN) {
        return `/membership/myinfo`;
      } else {
        // return `/membership/myinfo?service_code=${SERVICE_CODE}&ret=${incodeUrl}`;
        return `/membership/sns_email_auth_confirm`;
      }
    } else {
      return `/mypage/mypage_auth.asp`;
    }
  };

  return window.open(
    process.env.REACT_APP_MEMBER_DNS + service_type_link(),
    "_self"
  );
};

export const TERMS_URL =
  process.env.REACT_APP_MEMBER_DNS + "/common/center/useterms.html";

export const PRIVACY_URL =
  process.env.REACT_APP_MEMBER_DNS + "/common/center/unitedprivacy.html";
